import {
  GET_RESIDENT_SUMMARIES,
  GET_RESIDENT_SUMMARIES_SUCCESS,
  GET_RESIDENT_SUMMARIES_FAILURE,
  GET_RESIDENT_SUMMARY_DETAIL,
  GET_RESIDENT_SUMMARY_DETAIL_SUCCESS,
  GET_RESIDENT_SUMMARY_DETAIL_FAILURE,
  SAVE_SUMMARY_ANNOTATION,
  SAVE_SUMMARY_ANNOTATION_SUCCESS,
  SAVE_SUMMARY_ANNOTATION_FAILURE,
} from "./constants";

export const getResidentSummaries = (payload, onSuccess) => ({
  type: GET_RESIDENT_SUMMARIES,
  payload,
  onSuccess,
});
export const getResidentSummariesSuccess = (payload) => ({
  type: GET_RESIDENT_SUMMARIES_SUCCESS,
  payload,
});
export const getResidentSummariesFailure = (payload) => ({
  type: GET_RESIDENT_SUMMARIES_FAILURE,
  payload,
});

export const getResidentSummaryDetail = (payload, onSuccess) => ({
  type: GET_RESIDENT_SUMMARY_DETAIL,
  payload,
  onSuccess,
});
export const getResidentSummaryDetailSuccess = (payload) => ({
  type: GET_RESIDENT_SUMMARY_DETAIL_SUCCESS,
  payload,
});
export const getResidentSummaryDetailFailure = (payload) => ({
  type: GET_RESIDENT_SUMMARY_DETAIL_FAILURE,
  payload,
});

export const saveSummaryAnnotation = (payload, onSuccess) => ({
  type: SAVE_SUMMARY_ANNOTATION,
  payload,
  onSuccess,
});
export const saveSummaryAnnotationSuccess = (payload) => ({
  type: SAVE_SUMMARY_ANNOTATION_SUCCESS,
  payload,
});
export const saveSummaryAnnotationFailure = (payload) => ({
  type: SAVE_SUMMARY_ANNOTATION_FAILURE,
  payload,
});
